const requiredIcons = require.context(`../../static/images/icons`, false, /\.svg$/);

export default requiredIcons.keys().reduce(
  (object, key) => {
    const aaa = key.replace('./', '').replace('.svg', '');
    object[aaa] = requiredIcons(key);
    return object;
  }, {},
);
